
























import { Component, Vue } from 'vue-property-decorator';
import VSpacer from '@/components/commons/VSpacer.vue'; // @ is an alias to /src
import '@/utils/filter';
import {
  GardenCollectInterface,
  GardenSummaryInterface,
} from '@/interfaces/garden/garden.interface';
import { default as axios } from 'axios';
import { Utils } from '@/utils/utils';
import { ErrorInterface } from '@/interfaces/commons/error.interface';

@Component({
  components: {
    VSpacer,
  },
})
export default class GardenSummary extends Vue {
  private errorMessage: ErrorInterface;

  get gardenCollect(): GardenCollectInterface {
    return this.$store.state.gardenCollect;
  }

  constructor() {
    super();

    this.errorMessage = {
      message: '',
    };

    axios
      .get(`${process.env.VUE_APP_API_URL}/gardens/last`)
      .then(response => {
        const result: GardenCollectInterface = response.data as GardenCollectInterface;
        this.$store.dispatch('setGardenCollect', result);
      })
      .catch(err => {
        this.errorMessage.message = err;
      });
  }

  displayResult(item: GardenSummaryInterface) {
    if (item.type === 'boolean') {
      return item.value ? '✔️' : '❌';
    } else if (item.type === 'number') {
      return item.value === null ? '❌' : '✔️';
    }
  }

  displayValue(item: GardenSummaryInterface) {
    if (item.type === 'number' && item.value !== null) {
      return item.unit !== '' ? `${item.value} ${item.unit}` : item.value;
    }
    return '';
  }
}
